import { createApp } from 'vue'
import App from './App.vue'
import '@/assets/main.scss'
import 'remixicon/fonts/remixicon.css'
import VueLoading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { createStore } from 'vuex'
import router from './router'
import VueCountdown from '@chenfengyuan/vue-countdown';

// Create a new store instance.
const store = createStore({
    state () {
      return {
        isConnected: false,
        account: ""
      }
    },
    mutations: {
      changeConnectionStatus (state, newVal) {
        state.isConnected = newVal;
      },
      changeAccount (state, newVal) {
        state.account = newVal;
      }
    }
})


createApp(App)
    .component(VueCountdown.name, VueCountdown)
    .use(router)
    .use(VueLoading)
    .use(store)
    .mount('#app')
